import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

import { OrderAnalysisService } from '@app/services/myoffice/order/order-analysis.service';


import * as OrderAnalysisAction from '@app/actions/myoffice/order/order-analysis.action';
@Injectable()
export class OrderAnalysisEffect {

  constructor(
    private _actions$: Actions,
    private orderAnalysisService: OrderAnalysisService
  ) { }

  orderAnalysisByRank$ = createEffect(() => this._actions$.pipe(
    ofType(OrderAnalysisAction.orderAnalysicByRank),
    mergeMap(({year,userid,typesearch }) => this.orderAnalysisService.orderAnalysicByRank(year, userid , typesearch).pipe(
      map(res => OrderAnalysisAction.orderAnalysicByRankSuccess({ items: res })),
      catchError(msg => of(OrderAnalysisAction.orderAnalysicByRankFailure({ msg: msg })))
    ))
  ));

  orderAnalysisByAge$ = createEffect(() => this._actions$.pipe(
    ofType(OrderAnalysisAction.orderAnalysicByAge),
    mergeMap(({year,userid,typesearch }) => this.orderAnalysisService.orderAnalysicByAge(year, userid , typesearch).pipe(
      map(res => OrderAnalysisAction.orderAnalysicByAgeSuccess({ items: res })),
      catchError(msg => of(OrderAnalysisAction.orderAnalysicByAgeFailure({ msg: msg })))
    ))
  ));

  orderAnalysisByMonth$ = createEffect(() => this._actions$.pipe(
    ofType(OrderAnalysisAction.orderAnalysicByMonth),
    mergeMap(({year,userid,typesearch }) => this.orderAnalysisService.orderAnalysicByMonth(year, userid , typesearch).pipe(
      map(res => OrderAnalysisAction.orderAnalysicByMonthSuccess({ item: res })),
      catchError(msg => of(OrderAnalysisAction.orderAnalysicByMonthFailure({ msg: msg })))
    ))
  ));

  orderAnalysisByCate$ = createEffect(() => this._actions$.pipe(
    ofType(OrderAnalysisAction.orderAnalysicByCate),
    mergeMap(({year,userid,typesearch }) => this.orderAnalysisService.orderAnalysicByCate(year, userid , typesearch).pipe(
      map(res => OrderAnalysisAction.orderAnalysicByCateSuccess({ items: res })),
      catchError(msg => of(OrderAnalysisAction.orderAnalysicByCateFailure({ msg: msg })))
    ))
  ));


  orderAnalysisByProduct$ = createEffect(() => this._actions$.pipe(
    ofType(OrderAnalysisAction.orderAnalysicByProduct),
    mergeMap(({year,userid,typesearch }) => this.orderAnalysisService.orderAnalysicByProduct(year, userid , typesearch).pipe(
      map(res => OrderAnalysisAction.orderAnalysicByProductSuccess({ items: res })),
      catchError(msg => of(OrderAnalysisAction.orderAnalysicByProductFailure({ msg: msg })))
    ))
  ));
}